import React, { useState, useEffect } from 'react'
import { graphql } from 'gatsby'
import Layout from '../../templates/Master'
import Loader from '../../components/loaders/PageLoader'
import { connect } from 'react-redux'
import { onSnapshot, doc } from 'firebase/firestore'
import { db } from '../../system/firebase/index'
import { dialogState } from '../../system/redux/reducers/dialog'
import { previewState } from '../../system/redux/reducers/preview'
import TeamDetails from '../../templates/TeamDetails'

const DynamicTeamPost = ({
    data,
    dispatch,
    location,
    isAuthenticated,
    isVerifying,
    verificationComplete,
    previewID,
}) => {
    const fallback = <Loader />
    const [pageData, setPageData] = useState(false)
    const [collection, setCollection] = useState(false)
    const [id, setId] = useState(false)
    const queryParams = new URLSearchParams(location.search)
    const auxData = {
        collection: data.allCollection.edges,
        post: data.allPost.edges,
        page: data.allPage.edges,
        dynamic: true,
    }

    useEffect(() => {
        if (location.search) {
            if (
                queryParams.get('preview') === 'true' &&
                queryParams.get('id')
            ) {
                const col = queryParams.get('collection')
                const id = queryParams.get('id')
                setCollection(col)
                setId(id)
                dispatch(previewState(queryParams.get('id')))
            }
        }
    }, [location, isVerifying, isAuthenticated, verificationComplete])

    useEffect(() => {
        let isCancelled = false
        if (previewID) {
            const q = doc(db, queryParams.get('collection'), previewID)
            onSnapshot(q, (snapshot) => {
                if (!isCancelled) {
                    const output = []
                    if (snapshot.exists()) {
                        const data = snapshot.data()
                        if (
                            !isVerifying &&
                            !isAuthenticated &&
                            verificationComplete
                        ) {
                            dispatch(
                                dialogState(
                                    JSON.stringify({ open: true, id: 'LOGIN' })
                                )
                            )
                        } else {
                            output.push(data)
                        }
                    }
                    setPageData(output[0])
                }
            })
        }

        return () => {
            isCancelled = true
        }
    }, [
        collection,
        id,
        isVerifying,
        isAuthenticated,
        previewID,
        verificationComplete,
    ])

    const View = pageData ? (
        <TeamDetails
            data={pageData}
            auxData={auxData}
        />
    ) : (
        fallback
    )

    return (
        <Layout
            location={location}
            pageTitle={pageData?.title}
        >
            {View}
        </Layout>
    )
}
function mapStateToProps(state) {
    return {
        isAuthenticated: state.Auth.isAuthenticated,
        isVerifying: state.Auth.isVerifying,
        verificationComplete: state.Auth.verificationComplete,
        previewID: state.Preview.id,
    }
}
export default connect(mapStateToProps)(DynamicTeamPost)

export const query = graphql`
    query {
        allUser {
            nodes {
                uid
                first_name
                last_name
            }
        }
        allCollection(filter: { visibility: { eq: "public" } }) {
            edges {
                node {
                    media {
                        set {
                            filename
                            filepath
                            media_type
                            public_id
                        }
                    }
                    date_published
                    added_by
                    slug
                    title
                    item_id
                    categories
                    content {
                        description
                        excerpt
                    }
                    year
                    saleCurrency
                    salePrice
                    featuredImage {
                        filename
                        filepath
                        media_type
                        public_id
                    }
                    legacyWebProfileMedia {
                        set {
                            filename
                            filepath
                            media_type
                            public_id
                        }
                    }
                }
            }
        }
        allPost(filter: { visibility: { eq: "public" } }) {
            edges {
                node {
                    categories
                    content {
                        description
                        excerpt
                    }
                    media {
                        set {
                            caption
                            filename
                            filepath
                            media_type
                            public_id
                        }
                    }
                    date_added
                    slug
                    title
                    date_published
                }
            }
        }
        allPage(filter: { visibility: { eq: "public" } }) {
            edges {
                node {
                    content {
                        description
                        excerpt
                    }
                    media {
                        set {
                            caption
                            filename
                            filepath
                            media_type
                            public_id
                        }
                    }
                    date_added
                    slug
                    title
                    date_published
                }
            }
        }
    }
`
